import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d37bab6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d37bab6')) {
      api.createRecord('6d37bab6', component.options)
    } else {
      api.reload('6d37bab6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d37bab6", function () {
      api.rerender('6d37bab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reservation/index.vue"
export default component.exports